import { render } from "./ForgotPasswordView.vue?vue&type=template&id=09cef668&scoped=true&ts=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=09cef668&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cef668"]])

export default __exports__